import React, { FC, useEffect, useState, useContext } from 'react';
import { RouteComponentProps, withRouter, Redirect } from 'react-router-dom';
import styles from './Annotation.module.scss';
import { setupAnnotationManager } from './annotation.slice';
import { connect } from 'react-redux';
import { RootState } from '../../../rootReducer';
import { AppDispatch } from '../../../store';
import AnnotationFormModal from './AnnotationForm/AnnotationFormModal';
import AnnotationValidationModal from './AnnotationValidationModal/AnnotationValidationModal';
import HiddenViews from './HiddenViews';
import TreeContainer from './Tree/TreeContainer';
import SelectedNodeContainer from './SelectedNodeContainer';
import Overlay from '../../Shared/Overlay/Overlay';
import { ParserContext } from '../contexts/ParserContext';
import AnnotationMultiselectModal from './AnnotationMultiselectModal/AnnotationMultiselectModal';

type IProps = RouteComponentProps<{ parser: string }> & ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

const Annotation: FC<IProps> = ({
  match,
  location,
  redirectToRoot,
  showCreateAnnotationModal,
  showMultiAnnotationModal,
  validationModalData,
  fullScreenMode,
  loading,
  saveFinding,
  onSetupAnnotationManager
}) => {
  const [hideTree, setHideTree] = useState(false);
  const [hideStichedView, setHideStichedView] = useState(false);
  const [treeWidth, setTreeWidth] = useState<number>(0);
  const [loaded, setLoaded] = useState(false);

  const { parser } = useContext(ParserContext);

  useEffect(() => {
    if (parser.parsedRequiredPath(match.params) && !loaded) {
      setLoaded(true);
      onSetupAnnotationManager(parser.parsedRequiredPath(match.params), parser.containsSequence(parser.parsedFullPath(match.params)));
    }
  }, [loaded, location.pathname, match.params, onSetupAnnotationManager, parser]);

  if (redirectToRoot) {
    return <Redirect to='/annotation-manager'></Redirect>;
  }

  return (
    <>
      <div id='main-container' className={`${styles.mainContainer} container-fluid`}>
        <HiddenViews
          hideTree={hideTree}
          hideStichedView={hideStichedView}
          fullScreenMode={fullScreenMode}
          setHideTree={setHideTree}
          setHideStichedView={setHideStichedView}
        />
        <TreeContainer hideTree={hideTree} hideStichedView={hideStichedView} setTreeWidth={setTreeWidth} setHideTree={setHideTree} />
        <SelectedNodeContainer hideStichedView={hideStichedView} hideTree={hideTree} treeWidth={treeWidth} setHideStichedView={setHideStichedView} />
      </div>
      {showCreateAnnotationModal && !validationModalData.showModal && <AnnotationFormModal />}
      {showMultiAnnotationModal && <AnnotationMultiselectModal />}
      {validationModalData.showModal && <AnnotationValidationModal />}
      {(loading || saveFinding) && <Overlay />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  selectedName: state.annotation.selectedName,
  showCreateAnnotationModal: state.annotationForm.showCreateAnnotationModal,
  showMultiAnnotationModal: state.annotationForm.showMultiAnnotationModal,
  validationModalData: state.annotationValidationModal.validationModalData,
  sequenceStatuses: state.annotation.sequenceStatuses,
  fullScreenMode: state.annotation.fullScreenMode,
  loading: state.annotation.localizationLoading,
  redirectToRoot: state.annotation.redirectToRoot,
  saveFinding: state.canvas.saveFinding
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onSetupAnnotationManager: (requiredPathPart: string, containsSequence: boolean) =>
    dispatch(setupAnnotationManager(requiredPathPart, containsSequence))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Annotation));
